import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Embedding, EmbeddingQueryResponse} from './_models'
import { Company } from '../../../company/company-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/embeddings`


const getUsers = (query: string,userid : string, companyid : string): Promise<EmbeddingQueryResponse> => {
  return axios
  .get(`${USER_URL}/all/${companyid}?${query}`)
  .then((d: AxiosResponse<EmbeddingQueryResponse>) => d.data)
}


const getUserById = ( companyid : any,embeddingId : any,): Promise<Embedding | undefined> => {
  return axios
    .get(`${USER_URL}/single/${companyid}/${embeddingId}`)
    .then((response: AxiosResponse<Response<Embedding>>) => response.data)
    .then((response: Response<Embedding>) => response.data)
}



const createEmbeddings = (embeddings: any, companyId : String): Promise<Embedding | undefined> => {
  return axios
    .post(`${USER_URL}/${companyId}`, embeddings)
    .then((response: AxiosResponse<Response<Embedding>>) => response.data)
    .then((response: Response<Embedding>) => response.data)
}


const deleteFile = (fileID: ID, companyId : string): Promise<void> => {
  return axios.delete(`${USER_URL}/${companyId}/${fileID}`).then(() => {})
}


const generateEmbeddings = (embeddings: any): Promise<Embedding | undefined> => {
  embeddings.hostname = `${API_URL}`;
  console.log(embeddings);
  return axios
    .post(`${USER_URL}/generateEmbeddings`, embeddings,{
      timeout: 10000, 
    })
    .then((response: AxiosResponse<Response<Embedding>>) => response.data)
    .then((response: Response<Embedding>) => response.data)
}


const mergeFiles = (selectedIds : any,companyId : any): Promise<Embedding | undefined> => {
  return axios
    .post(`${USER_URL}/merge/${companyId}`, selectedIds)
    .then((response: AxiosResponse<Response<Embedding>>) => response.data)
    .then((response: Response<Embedding>) => response.data)
}


const deleteEmbedding = (userId: ID, companyId : string): Promise<void> => {
  return axios.delete(`${USER_URL}/${companyId}/${userId}`).then(() => {})
}


export {getUsers,  getUserById, createEmbeddings,deleteFile,generateEmbeddings,mergeFiles,deleteEmbedding}
